import React, { useEffect, useState } from "react";

const KEY = "tf_logo_reveal_seen";
const DURATION = 5400;
const MASK = { WebkitMaskImage: "url(/logo-mark.png)", maskImage: "url(/logo-mark.png)" };

export default function LogoReveal() {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
    return !sessionStorage.getItem(KEY);
  });
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!show) return;
    sessionStorage.setItem(KEY, "1");
    document.body.style.overflow = "hidden";
    const t1 = setTimeout(() => setLeaving(true), DURATION - 800);
    const t2 = setTimeout(() => setShow(false), DURATION);
    return () => { clearTimeout(t1); clearTimeout(t2); document.body.style.overflow = ""; };
  }, [show]);

  const skip = () => { setLeaving(true); setTimeout(() => setShow(false), 400); };
  if (!show) return null;

  return (
    <div className={`logo-reveal ${leaving ? "leaving" : ""}`} role="dialog" aria-label="TechAI Fortune intro" data-testid="logo-reveal">
      <div className="lr-mist lr-mist-a" aria-hidden="true" />
      <div className="lr-mist lr-mist-b" aria-hidden="true" />
      <div className="lr-stage">
        <div className="lr-mark">
          <img src="/logo-mark.png" alt="" className="lr-mark-img lr-silhouette" aria-hidden="true" />
          <div className="lr-trace" style={MASK} aria-hidden="true"><div className="lr-beam" /></div>
          <div className="lr-trace lr-trace-2" style={MASK} aria-hidden="true"><div className="lr-beam lr-beam-2" /></div>
          <img src="/logo-mark.png" alt="TechAI Fortune" className="lr-mark-img lr-final" />
          <div className="lr-flare" aria-hidden="true" />
        </div>
        <img src="/logo-wordmark-light.png" alt="TechAI Fortune — IT Consulting & Staffing" className="lr-wordmark" />
        <div className="lr-sweep" aria-hidden="true" />
      </div>
      <button type="button" onClick={skip} className="lr-skip" data-testid="logo-reveal-skip">Skip intro</button>
    </div>
  );
}
